import React from 'react';
import withIcon from '../utilities/withIcon';

const IconThumbsUpFilled = () => {
  return (
    <g>
      <path d="M10 2.509c.125.598.06 1.217-.048 1.737l-.068.298-.073.269-.166.567c-.02.08-.022.122 0 .122h5.105a1.249 1.249 0 1 1 0 2.494h-.5a1.249 1.249 0 1 1 0 2.494l-.5.001a1.249 1.249 0 1 1 0 2.494H13a.999.999 0 1 1 0 1.997L8.078 15l-1.526-.013-.13-.005c-.378-.023-.8-.155-1.263-.397A.3.3 0 0 1 5 14.32V6.172a.3.3 0 0 1 .122-.242c1.113-.812 1.834-1.54 2.162-2.182.15-.303.245-.653.328-1l.12-.51c.148-.606.32-1.117.769-1.226.33-.08 1.23.205 1.5 1.497zM2.8 6.001a.7.7 0 0 1 .7.699v7.084a.7.7 0 0 1-.7.699H.7a.7.7 0 0 1-.7-.699V6.7A.7.7 0 0 1 .7 6h2.1z" />
    </g>
  );
};

export default withIcon(IconThumbsUpFilled);
